import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../shared/services/api.service';
import { LineInterface } from '../models/line.interface';
import { ConsumptionInterface } from '../models/consumption.interface';
import { MsisdnListInterface } from '../models/msisdn-list.interface';
import { CustomerFilesInterface } from '../../shared/models/customer-files.interface';
import { LandLineDetailsInterface } from '../../landlines/models/land-line-details.interface';

@Injectable()
export class LinesService {

  constructor(private apiService: ApiService) {}

  /**
   * Get lines list
   */
  get(): Observable<Array<LineInterface>> {
    return this.apiService.get('gsm/lines');
  }

  /**
   * Get phone number details
   * @param phoneNumber
   */
  getPhoneNumberDetails(phoneNumber: string): Observable<LineInterface> {
    return this.apiService.get('gsm/line/' + phoneNumber);
  }

  /**
   * Get msisdn list
   */
  getMsisdnList(): Observable<Array<MsisdnListInterface>> {
    return this.apiService.get('gsm/customer/msisdn/list');
  }

  /**
   * Get available data refill services
   */
  getAvailableDataRefillServices(offerId: number): Observable<any> {
    return this.apiService.get<any>('stored-procedure/available/data/refill/services/' + offerId);
  }

  /**
   * Get phone number consumption
   * @param phoneNumber
   */
  getPhoneNumberConsumption(phoneNumber: string): Observable<ConsumptionInterface> {
    return this.apiService.get('front/line/' + phoneNumber + '/consumption');
  }

  getInitalLineTerminationDate(phoneNumber: string): Observable<any> {
    return this.apiService.get('initial/termination/date/' + phoneNumber);
  }

  downloadFileById(id: number): Observable<Blob> {
    const data = {
      fileId: id
    };
    return this.apiService.getFile('file/download', data);
  }

  files(details: object): Observable<Array<CustomerFilesInterface>> {
    return this.apiService.getFiles('files', details);
  }

  /**
   * Check available sim
   */
  checkAvailableSim(llccid: string): Observable<any> {
    return this.apiService.get<any>('extranet/sim/available/' + llccid);
  }

  /**
   * Get landline number details
   * @param landline
   */
  getLandlineDetails(landline: string): Observable<LandLineDetailsInterface> {
    return this.apiService.get<LandLineDetailsInterface>('customer/landline/details/'+landline);
  }
}
